import { IfAbility } from '@efdigital/ll-addon-auth';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditCohortCoaching } from '@efdigital/ll-admin-v2/components/programs/edit-cohort-coaching.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortCoachingIndexRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/coaching/index';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingIndexSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortCoachingIndexRoute>;
    controller: unknown;
  };
}

const ProgramsProgramCohortCoachingIndexTemplate: TemplateOnlyComponent<CoachingIndexSignature> =
  <template>
    {{pageTitle "Coaching"}}
    <div class="container py-5">
      <IfAbility @ability="coaching" @atLeast="viewer">
        <:if>
          <EditContext as |context|>
            <div class="row g-5">
              <div class="col-lg-8 col-xl-6 mx-auto">
                <IfAbility @ability="coaching" @atLeast="editor">
                  <:if>
                    <EditCohortCoaching
                      @cohort={{@model.cohort}}
                      @program={{@model.program}}
                      @coaching={{@model.coaching}}
                      @quizId={{@model.quizId}}
                      @coachingConfigs={{@model.coachingConfigs}}
                      @enrolledCount={{@model.enrolledCount}}
                      @coachPool={{@model.coachPool}}
                      @coaches={{@model.coaches}}
                      @client={{@model.client}}
                      @context={{context}}
                      @canEdit={{true}}
                    />
                  </:if>
                  <:else>
                    <EditCohortCoaching
                      @cohort={{@model.cohort}}
                      @program={{@model.program}}
                      @coaching={{@model.coaching}}
                      @quizId={{@model.quizId}}
                      @coachingConfigs={{@model.coachingConfigs}}
                      @enrolledCount={{@model.enrolledCount}}
                      @coachPool={{@model.coachPool}}
                      @coaches={{@model.coaches}}
                      @client={{@model.client}}
                      @context={{context}}
                      @canEdit={{false}}
                    />
                  </:else>
                </IfAbility>
              </div>
            </div>
          </EditContext>
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p>You do not have permission to view coaching configuration.</p>
            <p class="mb-0">Please contact your administrator if you believe you
              should have access.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>;

export default ProgramsProgramCohortCoachingIndexTemplate;
